exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___2wVoT {\n  padding: 96px 20px 40px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 768px) {\n  .container___2wVoT {\n    text-align: center;\n    padding: 52px 52px 40px;\n    display: block;\n  }\n}\n.title___X8nV1 {\n  margin-top: 0;\n  margin-bottom: 40px;\n}\n.tiles___30etH {\n  display: flex;\n  margin-bottom: 40px;\n}\n@media (max-width: 767px) {\n  .tiles___30etH {\n    flex-direction: column;\n  }\n}\n.tile___2vxeJ {\n  flex: 0 1 33.33%;\n  padding: 0 15px;\n  font-size: 16px;\n  line-height: 24px;\n}\n@media (max-width: 767px) {\n  .tile___2vxeJ {\n    display: flex;\n    align-items: center;\n    padding: 0;\n    margin-bottom: 30px;\n  }\n}\n.img___3g2tV {\n  max-width: 100%;\n  max-height: 100px;\n  display: block;\n  margin: 0 auto;\n}\n@media (min-width: 768px) {\n  .img___3g2tV {\n    margin-bottom: 20px;\n  }\n}\n@media (max-width: 767px) {\n  .dek___1mt6T {\n    margin-left: 20px;\n    font-size: 20px;\n    line-height: 28px;\n  }\n}\n.back___UYn8V {\n  position: fixed;\n  top: 20px;\n  left: 20px;\n}\n@media (min-width: 768px) {\n  .back___UYn8V {\n    display: none;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___2wVoT",
	"title": "title___X8nV1",
	"tiles": "tiles___30etH",
	"tile": "tile___2vxeJ",
	"img": "img___3g2tV",
	"dek": "dek___1mt6T",
	"back": "back___UYn8V"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionWelcomeModal/ConfigureAddressCollectionWelcomeModal.module.less
// module id = 2410
// module chunks = 71